/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthorizationOAuthAppDetails { 
    /**
     * Authorization OAuth app id
     */
    oauth_app_id?: string;
    /**
     * Authorization OAuth app name
     */
    oauth_app_name?: string;
    /**
     * Authorization OAuth app description
     */
    oauth_app_description?: string;
    /**
     * Organization id
     */
    org_id?: string;
    /**
     * Organization name
     */
    org_name?: string;
}

